import { Grid, Typography } from '@mui/material';
import ButtonSecondary from 'components/Button/ButtonSecondary';
import { FormattedMessage } from 'react-intl';
import _map from 'lodash/map';

export interface ButtonData {
    id: number;
    title: string;
    onClick: () => void;
}

const HeaderStep = ({ title, buttons }: { title: string; buttons: ButtonData[] }) => {
    return (
        <Grid container gap={2} sx={{ flexWrap: { xs: 'wrap', md: 'nowrap' } }} alignItems="center">
            <Grid item xs={12} md={6}>
                <Typography variant="h3" fontWeight={400}>
                    <FormattedMessage id={title} />
                </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                <Grid container sx={{ flexWrap: { xs: 'wrap', md: 'nowrap' } }} gap={2} justifyContent={buttons.length === 1 ? 'end' : ''}>
                    {_map(buttons, ({ id, onClick, title: titleButton }) => (
                        <Grid item xs={12} md={6} key={id}>
                            <ButtonSecondary title={titleButton} onClick={onClick} />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default HeaderStep;
